import { render, staticRenderFns } from "./arviointityokalut-listaus.vue?vue&type=template&id=7bd1d864&scoped=true&"
import script from "./arviointityokalut-listaus.vue?vue&type=script&lang=ts&"
export * from "./arviointityokalut-listaus.vue?vue&type=script&lang=ts&"
import style0 from "./arviointityokalut-listaus.vue?vue&type=style&index=0&id=7bd1d864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd1d864",
  null
  
)

export default component.exports